import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	homePageTitle: {
		id: 'spa-apps-servicedesk-reports-home-page.home-page-title',
		defaultMessage: 'Reports',
		description: 'Reports Home Page',
	},
	newReportButton: {
		id: 'spa-apps-servicedesk-reports-home-page.new-report-button',
		defaultMessage: 'Create new report',
		description: 'Add new report button',
	},
});
